import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import store from './store/index'
import router from './routes'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { VueMaskDirective } from 'v-mask'
import firebase from './plugins/firebase'

import './assets/scss/main.scss'
import './registerServiceWorker'
import './api'
import './env'
import './models'
import './utils/mixins/helper'

Vue.use(VueMeta)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.directive('mask', VueMaskDirective)

Vue.config.productionTip = false
store.dispatch('auth/init')

new Vue({
  router,
  store,
  firebase,
  render: h => h(App)
}).$mount('#app')
